module.exports = __webpack_public_path__ + "static/turtle-creek-house37-c11ee13bfba1555d1afa106d06807fbb.jpg";